var unified_emoji_ranges = [
    '\ud83c[\udf00-\udfff]',
    '\ud83d[\udc00-\ude4f]',
    '\ud83d[\ude80-\udeff]',
];
var emojiRegex = new RegExp(unified_emoji_ranges.join('|'), 'g');
export var isOnlyEmojis = function (str) {
    return (str === null || str === void 0 ? void 0 : str.replace(emojiRegex, '').length) === 0;
};
export var countEmojis = function (str) {
    var _a;
    return ((_a = str === null || str === void 0 ? void 0 : str.match(emojiRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0;
};
export var emojiFontSize = function (text) {
    var emojiCount = countEmojis(text);
    switch (emojiCount) {
        case 3:
            return '20px';
        case 2:
            return '30px';
        case 1:
            return '48px';
        default:
            return '20px';
    }
};
//# sourceMappingURL=emoji-utils.js.map